import { createTheme } from '@mui/material/styles';

export const primaryColor = '#6414db';
const defaultColor = '#C7C6C6';

const themeBasic = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    info: {
      main: defaultColor,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 992,
      lg: 1400,
      xl: 1536,
    },
  },
});

export { themeBasic };
